<template>
  <div class="menucontrol-scroll fixed-top">
    <Banner />
    <Management />
  </div>
</template>
<script>
import Banner from "./components/Banner.vue";
import Management from "./components/Management.vue";
export default {
  components: {
    Banner,
    Management,
  },
  data() {
    return {};
  },
};
</script>
